<template>
  <div class="reply-to">
    <div v-if="!replyTo" class="card tweet-card">
      <div class="card-content">
        <div class="media">
          <div class="media-content py-1">
            <div class="reply-to-box">
              <tweet-url
                  @tweetValidated="(data) => $store.commit('setReplyTo', data)"
                  @tweetFailed="$store.commit('clearReplyTo')"
                  :placeholder="placeholderText()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <tweet v-else
           @clear="clear"
           :show-delete="true"
           :show-line-down="true"
           :data="replyTo"
           :collapsed="!$store.getters.settings('compose','viewReply')" />
  </div>

</template>

<script>

import Tweet from "../tweet/Tweet"
import TweetUrl from "../TweetUrl";

export default {
  name: "ReplyTo",
  components: {TweetUrl, Tweet},

  computed: {
    replyTo() {
      // map the state reply-to field to a local property
      return this.$store.getters.replyTo
    }
  },

  methods: {
    clear() {
      this.text_input = ''
      this.$store.commit('clearReplyTo')
    },
    placeholderText() {
      return 'Replying to a tweet?'
    }
  }

}
</script>


<style lang="scss" scoped>

.card-content {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  transition: padding-top 0.1s, padding-bottom 0.1s;
}

.card-content:focus-within {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.reply-to-box {
  margin-left: 1rem;
}
</style>
